import API from './fetch'
import { cancellationPolicyURL } from './url'
import { generateParamsURL } from 'utilities/paramsFormat'
import _find from 'lodash/find'
import _reject from 'lodash/reject'
import _sortBy from 'lodash/sortBy'
import i18n from '../i18n'

const CancellationPolicies = {
  indexApi(query = {}, hotelId) {
    return API.getData(
      generateParamsURL(cancellationPolicyURL(hotelId), query, ['room_plan_codes'])
    )
  },
  get(id, hotelId) {
    return API.getData(`${cancellationPolicyURL(hotelId)}/${id}`).then((res) => {
      const parts = _sortBy(res?.data?.cancellation_policy_parts, 'days_before').reverse()
      const cancelRateOnTheDay = _find(parts, { days_before: 0 })?.percentage_of_cost ?? 100
      const restParts = _reject(_reject(parts, { days_before: 0 }), { percentage_of_cost: 0 })
      const freeDayThreshold = (parts[0]?.days_before || 0) + 1
      return {
        ...res,
        lines: [
          i18n.t('cancellationPolicy.policyHeader'),
          i18n.t('cancellationPolicy.freePolicyLine', [freeDayThreshold]),
          ...restParts.map((part) =>
            i18n.t('cancellationPolicy.policyLine', [part.days_before, part.percentage_of_cost])
          ),
          i18n.t('cancellationPolicy.cancelOnTheDay', [cancelRateOnTheDay]),
          i18n.t('cancellationPolicy.noShowLine', [res.data.no_show_percentage_of_cost])
        ]
      }
    })
  }
}

export default CancellationPolicies
